import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal } from 'antd';
import { CloseSquareOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import IframeElementCallback from './IframeElementCallback';
import Util from '../../script/util';
import './IframModal.scss';

class IframModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      url: null,
      width: 550,
      height: 800,
      zIndex: 1005,
    };
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.iframeElementCallback);
  }

  showModal = (url, param = {}) => {
    const width = param?.width || 550;
    const height = param?.height || 800;
    if (
      window.eleEvents &&
      Util.checkClientVersion(318) &&
      param?.standAlone &&
      window?.ddElectron?.initChildBrowserWindow
    ) {
      window.ddElectron.initChildBrowserWindow({
        url,
        width,
        height,
      });
    } else {
      this.setState({
        url: url,
        visible: true,
        width,
        height,
        zIndex: param?.zIndex || 1005,
        isGlobal: param?.isGlobal || false,
      });
      this.callback = param.callback;
    }

    window.addEventListener('message', this.iframeElementCallback);
  };
  hideModal = () => {
    this.setState({
      visible: false,
      url: null,
    });
    // 关闭 iframe 需要删除监听函数
    this.props.destroy && this.props.destroy();
    this.callback && this.callback();
    this.callback = null;

    window.removeEventListener('message', this.iframeElementCallback);
  };
  // 返回 iframe 的DOM节点
  getIframeElement = () => {
    return this.iframeElement;
  };

  iframeElementCallback = (msg) => {
    IframeElementCallback(this.props, msg, this.iframeElement, this.hideModal);
  };
  render() {
    const { width, height, zIndex } = this.state;
    return (
      <Modal
        open={this.state.visible}
        wrapClassName="iframe-body"
        centered={true}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width={`${width}px`}
        zIndex={zIndex}
        onCancel={this.hideModal}
      >
        <div
          className="iframe-modal-plan noDrag"
          style={{ paddingRight: 50, height }}
        >
          {this.state.url ? (
            <span>
              <span className="close" onClick={this.hideModal}>
                <CloseSquareOutlined />
              </span>
              <iframe
                ref={(el) => {
                  this.iframeElement = el;
                }}
                src={this.state.url}
                title="modal"
                frameBorder="0"
                scrolling="yes"
                width={width - 50}
                height={height}
              />
            </span>
          ) : null}
        </div>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(IframModal, { withRef: true })
);
